import newChatIcon from '../assets/img/chat.png';
import newUserIcon from '../assets/img/follow.png';

export const SENTRY_DSN = "https://96dc1d307a1a4221a6e9cc5c88bd8b47@o376633.ingest.sentry.io/5210599";
export const CLOUD_URL = "https://us-central1-oriserve-bcd30.cloudfunctions.net";
export const NETWORK_CHECK_URL = "https://www.google.com/";
export const BASE_URL_USERS = "https://indigo-test.oriserve.com/";
export const BASE_URL = "https://indigo-test.oriserve.com/";
export const BASE_SOCKET_URL = "https://indigo-test.oriserve.com/";

export const SOCKET_URLS = {
  LIVE_CONVERSATIONS_SOCKET_URL: `${BASE_SOCKET_URL}liveConversations`,
  LIVE_STATISTICS_SOCKET_URL: `${BASE_SOCKET_URL}liveChatsStats`,
  MEMBER_SOCKET_URL: `${BASE_SOCKET_URL}liveAdmins`,
};

export const BRAND_INFO = {
  name: 'ori serve',
  shortend_name: 'ori',
  logo_url: 'https://d113ddgi4j6d7k.cloudfront.net/dashboard/ori_logo.png',
  app_sider_logo: "https://d113ddgi4j6d7k.cloudfront.net/dashboard/ori_logo.png",
  bot_icon_url: 'https://d113ddgi4j6d7k.cloudfront.net/dashboard/defaultBotIcon.png',
  notification_header: 'ORI',
  new_msg_notification_icon_url: newChatIcon,
  new_customer_notification_icon_url: newUserIcon,
  usage_home_page: false, // by default it should be false
  data: {
    socket_query: {
      brandName: 'dishtv',
      channelName: 'web',
      role: 'admin'
    }
  }
};

export const MODULE_CONFIG = {
  GLOBAL: {
    DIAGNOSE: true,
    AUTO_LOGOUT: {
      POPUP_TITLE: 'Your session will expire soon',
      POPUP_CONTENT: 'you are not intracting with dashboard so you will be logout soon',
      SHOW_POPUP_TIME: 45 * 60000, // 45 min
      AUTO_LOGOUT_TIME: 2 * 60000  // 2 min
    },
    INTENT_THRESHOLD_SCORE: 0.5,
    AGENT_LIVE_KPI_POLLING_INTERVAL: 10 * 60000, // 10 min (minimun 2 min bz it is using ajax request)
    HISTOGRAM_X_AXIS_CHARACTER_SPLIT_COUNT: 30,
    WHATSAPP_FILE_UPLOAD_ALLOWED_TYPES: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
  },
  ANALYTICS: {
    AGENT_MONITORING: {
      LIVE_GROUPS_POLLING_TIME_INTERVAL: 5000,
      LIVE_AGENTS_POLLING_TIME_INTERVAL: 10000,
    },
  },
  CHATS: {
    ALLOW_UNTAGGED_CHAT: false,
    STORED_LIVE_CHAT_ITEMS_COUNT: 4,
    LONG_CHAT_HANDLING_TIME: 120000, // in miliseconds
    CRITICAL_CHAT_HANDLING_TIME: 300000, // in miliseconds
    EDITOR: {
      BOLD: true,
      ITALIC: true,
      UNDERLINE: true,
      STRIKE: true,
      FORMATS: ["bold", "italic", "underline", "strike"],
      STRIP_PASTED_STYLES: true
    }
  },
  HISTORY: {
    FILTER_ON_PRESS_ENTER: true
  },
  MEMBERS: {
    MAX_INVITE_AGENT_COUNT_USING_CSV: 20,
    SAMPLE_CSV_URL: 'https://s3.ap-south-1.amazonaws.com/oriserve.com/users-csv/sample.csv',
    MEMBERS_PER_PAGE_IN_EDIT_GROUP: 5
  },
  CONSOLE: {
    REPORTS_PER_PAGE_TABLE_DATA: 10
  }
};

export const MODULE_MESSAGE = {
  AUTH: {
    LOGIN: {
      title: `Welcome to ${BRAND_INFO.shortend_name} dashboard`,
      description: "Please enter your email and password. Login to continue..",
    },
    FORGOT_PASSWORD: {
      title: "Forgot Your Password?",
      description: `To reset your password, please enter your Email id. ${BRAND_INFO.shortend_name} dashboard will send the password reset instructions to the email address for this account.`,
      request_success_title: "Verification link sent",
      request_success_description: "A password reset message has been sent to your email address. please click the link in the message to reset your password.",
    },
    RESET_PASSWORD: {
      description: "To reset your password, Enter new password and confirm password. Password must have atleast five character.",
      token_error_title: "Invalid token",
      token_error_description: "you are not authorized to perform this action. your token is either invalid or it has been expired Please click on 'Forgot Password' and create new request to reset your password."
    },
    ACTIVATE_USER: {
      description: `Welcome to ${BRAND_INFO.shortend_name} dashboard, Start with chossing passoword. Password must have atleast five character.`,
      token_error_title: "Verification Failed",
      token_error_description: "you are not authorized to perform this action. your token is either invalid or it has been expired Please ask your admin to create new activation link.",
      request_success_title: "Activation link sent",
      request_success_description: `A user activation link has been sent to your email address. please click the link in the message to activate your ${BRAND_INFO.shortend_name} dashboard account.`,
    }
  },
  DASHBOARD: {},
  ANALYTICS: {
    CHATLOGS: {},
    USAGES: {
      share_report: '',
    }
  },
  MEMBERS: {
    AGENTS: {
      invite_using_csv: 'select a csv file same as sample.csv. we will read data from csv file and allow you to invite them. i suggest you to verify all agents data before click on invite button',
      invite_manually: 'click on the below button and manually enter each agent required information and invite them.'
    }
  },
  SETTINGS: {
    TEAM_MEMBER_SETTING: {
      add_member_status: 'Your team is the face of your business, engaging and conversing with your users. You can see the full list of team members, add new members, and edit member details from this page.',
      MEMBER_PERMISSIONS: {
        not_access: "you don't have privileges to change the member's permission with this credentials. you can contact your administrator.",
        self_account: "you can not change your permissions yourself. you can contact your administrator to change your permissions."
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/data/config/urls.js